import { listActiveComponentEntries } from "./listActiveComponentEntries";
import type { ComponentStoreData } from "./types";

/**
 * Returns non-empty values per component, excluding any value listed in `deactivatedValues`.
 * Component keys are kept even when every value is empty or deactivated (the array may be []).
 */
export const cleanComponentNameToValues = (
  componentStoreData: Partial<ComponentStoreData> | null
): Map<string, string[]> => {
  const result = new Map<string, string[]>();
  const components = componentStoreData?.components;
  const deactivatedValues = componentStoreData?.deactivatedValues ?? {};
  if (components) {
    for (const [componentName, rawValues] of Object.entries(components)) {
      const deactivatedValuesForComponent = new Set(deactivatedValues[componentName] ?? []);
      // the default is many empty strings, so we have to clean them
      result.set(
        componentName,
        listActiveComponentEntries(rawValues ?? [], deactivatedValuesForComponent).map(({ value }) => value)
      );
    }
  }
  return result;
};
